import React, { Fragment, useEffect, useMemo, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import ExportCSV from "../../../components/ExportCsv/ExportCsv";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import { HiOutlinePlus } from "react-icons/hi";
import {
    useCountFeedbackMutation,
    useFetchFeedbackMutation,
} from "../../../features/tenant/feedback/feedBackApi";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { useFetchCenturySkuProductMapMutation, useFetchCenturySkuProductMapCountMutation, useFetchCenturySkuCsvProductMapMutation, useBulkUploadSkuProductMapMutation } from "../../../features/tenant/skuProductMap/skuProductMapApi";
import { Menu } from "@headlessui/react";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { downloadSampleCSV } from "../../../utils/downloadSampleCsv";
import toast from "react-hot-toast";

const SkuProductMap = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [
        FetchSkuProductMap,
        {
            data: FetchSkuProductMapData,
            error: FetchSkuProductMapError,
            isLoading: FetchSkuProductMapIsLoading,
            isError: FetchSkuProductMapIsError,
        },
    ] = useFetchCenturySkuProductMapMutation();

    const [
        bulkUploadSkuProductMap,
        {
            data: bulkUploadSkuProductMapData,
            error: bulkUploadSkuProductMapError,
            isLoading: bulkUploadSkuProductMapIsLoading,
            isError: bulkUploadSkuProductMapIsError,
        },
    ] = useBulkUploadSkuProductMapMutation();

    const [
        fetchCenturySkuCsvProductMap,
        {
            data: fetchCenturySkuCsvProductMapData,
            error: fetchCenturySkuCsvProductMapError,
            isLoading: fetchCenturySkuCsvProductMapIsLoading,
            isError: fetchCenturySkuCsvProductMapIsError,
        },
    ] = useFetchCenturySkuCsvProductMapMutation();

    const [
        CountSkuProductMap,
        {
            data: CountSkuProductMapData,
            error: CountSkuProductMapError,
            isLoading: CountSkuProductMapIsLoading,
            isError: CountSkuProductMapIsError,
        },
    ] = useFetchCenturySkuProductMapCountMutation();

    const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme
        .color_shades;


    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const currentDate = new Date().toISOString().split("T")[0];
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);
    const [skuProductMap, setSkuProductMap] = useState([]);
    const [skuCsvProductMap, setSkuCsvProductMap] = useState([])
    const [showModal2, setShowModal2] = useState(false);
    const [file, setFile] = useState();
    const [userTypesArray, setUserTypesArray] = useState({
        name: "All",
        id: null,
    });
    const initialRequest = {
        sku_code: "",
        limit: 10,
        offset: 0,
        product_code: ""
    };
    const [request, setRequest] = useState(initialRequest);

    useEffect(() => {
        if (FetchSkuProductMapData?.body?.skuList) {
            setSkuProductMap(FetchSkuProductMapData.body.skuList);
        }
    }, [FetchSkuProductMapData]);

    useEffect(() => {
        console.log(fetchCenturySkuCsvProductMapData, fetchCenturySkuCsvProductMapError)
        if (fetchCenturySkuCsvProductMapData?.body?.skuList) {
            setSkuCsvProductMap(fetchCenturySkuCsvProductMapData.body.skuList);
        }
    }, [fetchCenturySkuCsvProductMapData]);


    useEffect(() => {
        if (bulkUploadSkuProductMapError) {
            toast.error(bulkUploadSkuProductMapError?.data?.message)
        }
        if (bulkUploadSkuProductMapData) {
            toast.success("SKU Added");
            fetchFetchSkuProductMapFunction()
        }
    }, [bulkUploadSkuProductMapData, bulkUploadSkuProductMapError])


    useEffect(() => {
        fetchFetchSkuProductMapFunction();
        fetchCountSkuProductMapFunction();
    }, [location.pathname, limit, offset]);

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setCurrentPage(pageNumber);
        setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);
        setRequest((prevRequest) => ({
          ...prevRequest,
          limit: newPerPage,
          offset: 0,
        }));
    };

    useEffect(() => { }, [request]);
    const fetchFetchSkuProductMapFunction = (row) => {
        FetchSkuProductMap({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: request,
        });
    };

    const fetchCountSkuProductMapFunction = (row) => {
        CountSkuProductMap({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: request,
        });
    };

    useEffect(() => {
        fetchCenturySkuCsvProductMap({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        })
    }, [])

    // FetchCsvFeedback

    const clearFilters = () => {
        setRequest(initialRequest);
    };
    useEffect(() => {
        if (
            request.sku_code === "" &&
            request.product_code === ""
        ) {
            fetchFetchSkuProductMapFunction();
            // fetchFetchCsvFeedbackFunction();
        }
    }, [request]);

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "sku_code",
            cell: (row) => <div>{row.sku_code}</div>,
            sortable: true,
        },

        {
            name: "product_code",
            cell: (row) => row.product_code,
            sortable: true,
        }
    ];

    function downloadCSVFromJSON(row, fileName) {
        if (!row || row.length === 0) {
            console.error("downloadCSVFromJSON: Empty JSON");
            return;
        }

        // Extract headers
        const headers = Object.keys(row[0]);

        // Convert JSON to CSV format
        const escapeCSV = (value) => {
            if (value === null || value === undefined) return "";
            const str = String(value);
            // Escape quotes and wrap fields with commas
            if (str.includes(",") || str.includes('"') || str.includes("\n")) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const csvRows = [
            headers.join(","), // header row
            ...row.map((row) =>
                headers.map((field) => escapeCSV(row[field])).join(",")
            )
        ];

        const csvString = csvRows.join("\n");

        // Create a Blob
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        // Create hidden download link
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName.endsWith(".csv") ? fileName : fileName + ".csv");
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    const handleOnChange = (e) => {
        setFile(e.target.files[0]);
    };

    function parseCSV(string) {
        const csvHeader = string
            .slice(0, string.indexOf("\n"))
            .replace(/\s/g, "")
            .split(",");

        const csvRows = string.slice(string.indexOf("\n") + 1).split(/\r?\n/);
        const array = csvRows
            .map((row) => {
                const values = [];
                let insideQuotes = false;
                let currentField = "";

                for (let char of row) {
                    if (char === "," && !insideQuotes) {
                        values.push(currentField.trim());
                        currentField = "";
                    } else if (char === '"') {
                        insideQuotes = !insideQuotes;
                    } else {
                        currentField += char;
                    }
                }

                values.push(currentField.trim());
                return values;
            })
            .filter((values) => values.length === csvHeader.length)
            .map((values) => {
                const obj = csvHeader.reduce((object, header, index) => {
                    object[header] = values[index].trim();
                    return object;
                }, {});
                return obj;
            });

        // console.log("array", array);
        return array;
    }

    const handleOnSubmit = (e) => {
        if (e) {
            e.preventDefault();
        }

        if (!file) {
            toast.error("Please select a file");
            return;
        }

        const fileReader = new FileReader();
        if (file) {
            fileReader.onload = function (event) {
                const text = event.target.result;
                let datas = parseCSV(text);
                let payload = {
                    "rows": datas
                }
                console.log(payload)
                handleBulkUploadSku(payload);
                // handleBulkUploadOrders(payload);
            };
            fileReader.readAsText(file);
        }
    };

    const handleBulkUploadSku = (data) => {
        if (
            window.confirm(`Confirm adding orders?`)
        ) {
            console.log(data)
            bulkUploadSkuProductMap({
                token: sessionStorage.getItem("access_token"),
                tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
                body: data,
            });
            setShowModal2(false);
        }
        return;
    };

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Sku Product Map
                        <LinksComponent />
                    </div>



                    <div className="p-2">

                        <div className="flex mt-1">
                            <button
                                className="btn btn-outline-primary clear-both   mb-2"
                                onClick={() => {
                                    setShowModal2(true);
                                }}
                            >
                                Add SKU Csv
                            </button>
                            <button
                                className="btn btn-outline-primary clear-both mb-2 ml-3"
                                onClick={() => {
                                    downloadCSVFromJSON(skuCsvProductMap, `SKU_Product_Map.csv`)
                                }
                                }
                            >
                                Download CSV
                            </button>
                        </div>

                        <div className=" w-full bg-white shadow rounded-lg">
                            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
                                <div className="flex opt_w100 space-x-2 ">
                                    <div className="w-52 ">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                SKU Code
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                                                placeholder="SKU Code..."
                                                required
                                                value={request.sku_code}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => {
                                                        return { ...prevState, sku_code: newValue };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="w-52 ">
                                        <div className="relative searchin">
                                            <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                                Product Code
                                            </label>
                                            <input
                                                type="search"
                                                id="default-search"
                                                className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500  inputp"
                                                placeholder="Product Code..."
                                                required
                                                value={request.product_code}
                                                onChange={(e) => {
                                                    const newValue = e.target.value;
                                                    setRequest((prevState) => {
                                                        return { ...prevState, product_code: newValue };
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="">
                                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                                            &nbsp;
                                        </label>

                                        <div className="flex flex-row  gap-2 ">
                                            <div className="relative searchin">
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right  pdbtn_all"
                                                    onClick={() => {
                                                        fetchFetchSkuProductMapFunction();

                                                        // fetchFetchCsvFeedbackFunction();
                                                    }}
                                                >
                                                    Search
                                                </button>
                                            </div>
                                            <div className="relative searchin">
                                                <button
                                                    className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                                                    onClick={() => {
                                                        clearFilters();
                                                    }}
                                                >
                                                    Clear Filter
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="p-3">
                                <DataTableComponent
                                    keyField={(row) => row.SNo}
                                    columns={columns}
                                    data={skuProductMap.length && skuProductMap}
                                    totalRows={
                                        CountSkuProductMapData && CountSkuProductMapData.body.total_sku
                                    }
                                    handlePerRowsChange={handlePerRowsChange}
                                    handlePageChange={handlePageChange}
                                    paginationDefaultPage={currentPage}
                                    paginationResetDefaultPage={paginationResetToggle}
                                ></DataTableComponent>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="fixed bottom-0 right-16 w-16 h-16 mr-10 mb-2 cursor-pointer"
                    id="box_btn"
                >
                    <div className="text-right">
                        <Menu className="relative inline-block text-left">
                            <div>
                                <Menu.Button
                                    onClick={() => navigate(`add`)}
                                    className="inline-flex justify-cente w-12 h-12 rounded-full text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 "
                                    style={{ backgroundColor: `${primaryColor["700"]}` }}
                                >
                                    <HiOutlinePlus className="w-full h-full p-3" />
                                </Menu.Button>
                            </div>
                        </Menu>
                    </div>
                </div>
                {showModal2 && (
                    <ModalComponent show={showModal2} setShow={setShowModal2} size="md">
                        <div className="w-full p-4">
                            {
                                <div className="flex justify-center mt-3 mb-3">
                                    <button
                                        type="submit"
                                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                                        onClick={() =>
                                            downloadSampleCSV([
                                                {
                                                    name: "skuCode",
                                                },
                                                {
                                                    name: "productCode",
                                                }
                                            ])
                                        }
                                    >
                                        Sample Csv Download
                                    </button>
                                </div>
                            }
                            <div className="w-full m-auto  justify-center ">
                                <div className="flex items-center justify-center w-full">
                                    <label
                                        for="dropzone-file"
                                        className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                                    >
                                        <div className="flex flex-col items-center justify-center ">
                                            <svg
                                                aria-hidden="true"
                                                className="w-20 h-20 mb-3 text-gray-400 mt-2"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    strokeLinejoin="round"
                                                    stroke-width="2"
                                                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                                ></path>
                                            </svg>
                                            <p className="mb-2 text-sm text-gray-500 text-center">
                                                <span className="font-semibold">Choose CSV file</span>
                                                <div>Click to upload or drag and drop</div>
                                            </p>
                                        </div>
                                        <input
                                            id="dropzone-file"
                                            type="file"
                                            className="hidden"
                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                          onChange={handleOnChange}
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="flex justify-center mt-3">
                                <button
                                    type="submit"
                                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                                  onClick={(e) => handleOnSubmit()}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </ModalComponent>
                )}
            </div>
        </>
    );
};

export default SkuProductMap;
